import { Badge } from 'components/ui/badge';
import { cn } from 'utils/cn';
import { t } from 'utils/getTranslations';
import { DateBasis, ReportEntry } from './reportCatalog';

type ReportTag = DateBasis | 'CUSTOM';

/** Each tag keeps one colour on every report screen, so a reader learns which date a colour stands for. */
const TAG_LOOKS: Record<ReportTag, { labelId: string; className: string }> = {
    TIMECARD_DATE: {
        labelId: 'reporting.filter.date-basis-timecard-date',
        className: 'bg-report-tag-timecard text-report-tag-timecard-ink',
    },
    INVOICE_DATE: {
        labelId: 'reporting.filter.date-basis-invoice-date',
        className: 'bg-report-tag-invoice text-report-tag-invoice-ink',
    },
    SERVICE_DATE: {
        labelId: 'reporting.filter.date-basis-service-date',
        className: 'bg-report-tag-service text-report-tag-service-ink',
    },
    CUSTOM: { labelId: 'reporting.tag.custom', className: 'bg-report-tag-custom text-report-tag-custom-ink' },
};

type Props = {
    report: ReportEntry;
    /** The date tags to show, the report's own by default; the header shows only the date the report is filtered by. */
    dateBases?: DateBasis[];
    className?: string;
};

/** A report's tags: the dates its period can bound, its default first, and Custom on a report only some firms have. */
export function ReportTags({ report, dateBases = report.dateBases, className }: Props) {
    const tags: ReportTag[] = report.featureFlag ? [...dateBases, 'CUSTOM'] : dateBases;
    if (tags.length === 0) {
        return null;
    }
    return (
        <ul
            aria-label={t('reporting.tags')}
            className={cn('m-0 flex list-none flex-wrap items-center gap-1 p-0', className)}
        >
            {tags.map((tag) => (
                <li key={tag} className="flex">
                    <Badge className={cn('border-transparent', TAG_LOOKS[tag].className)}>
                        {t(TAG_LOOKS[tag].labelId)}
                    </Badge>
                </li>
            ))}
        </ul>
    );
}
